import { unhandledRequest } from '../request';

export type FavoriteContentType = 'application' | 'job';

export type UserFavorite = {
  contentType: FavoriteContentType;
  id: number;
  objectId: number;
  name: string;
  jobId: number;
};

export const loadUserFavoriteList = async () => {
  const response = await unhandledRequest.get({ url: 'v1/favorites/' });
  return response.data as UserFavorite[];
};

export const deleteUserFavorite = async (id: UserFavorite['id']) => {
  const response = await unhandledRequest.delete({ url: `v1/favorites/${id}/` });
  return response.data;
};

export const addUserFavorite = async (data: Pick<UserFavorite, 'contentType' | 'objectId'>) => {
  const response = await unhandledRequest.post({ url: 'v1/favorites/', data });
  return response.data;
};
